<template>
    <div class="sidebar-card">
        <h1 class="heading-border-bottom-anim">{{dlabData.questions.rightSidebar.achivementCard.title}}</h1>

        <div class="sidebar-card-achivement d-flex flex-wrap w-full justify-content-between">
            <div v-for="(item, i) in dlabData.questions.rightSidebar.achivementCard.items" :key="i" class="sidebar-card-list-box">
                <h1>{{item.number}}</h1>
                <p>{{item.designation}}</p>
            </div>
            <div class="sidebar-card-list-box">
                <p>To get answer of question <a href="#">Join</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import dlabData from '@/store/store.js'

export default {
    name: 'CounterAchivement',
    data() {
        return {
            dlabData
        }
    }
}
</script>